module.exports = __webpack_public_path__ + "static/media/userDetailsPage.a84a6267.jpg";